import { produce } from 'immer';

import { DeleteInternalBanners } from '../../../actions/bannersEdit/internal/deleteInternalBanners';
import { BannerId } from '../../../typings/banners';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function deleteInternalBanners(
    state: EditInternalBannersState,
    action: DeleteInternalBanners
): EditInternalBannersState {
    return produce(state, draft => {
        action.bannersIds.forEach((bannerId: BannerId) => {
            const groupId = draft.banners[bannerId].group.id;

            // потом удаляем баннеры или помечаем их для удаления
            if (draft.banners[bannerId].isNew) {
                draft.groupBannersList[groupId].bannersIds = draft.groupBannersList[groupId].bannersIds.filter(
                    id => id !== bannerId
                );

                delete draft.banners[bannerId];
                // из bannersDraft удаляются только новые объявления, текущие можно будет восстановить
                delete draft.bannersDraft[bannerId];
            } else {
                draft.banners[bannerId].markedForDeletion = true;
            }

            draft.groupBannersList[groupId].bannersTotal -= 1;
        });
    });
}
